import { useProduct } from "src/context/ProductProvider";
import ALaCartePaymentInformation from "./components/ALaCartePaymentInformation";
import PaymentInformation from "./components/PaymentInformation";
import { useLocation } from "react-router-dom";
import { Paths } from "src/constants/paths";
import DashboardALaCartePaymentInformation from "./components/DashboardALaCartePaymentInformation";
import BirthControlPaymentInformation from "./components/BirthControlPaymentInformation";
import MaleHairLossPaymentInformation from "./components/MaleHairLossPaymentInformation";
import FemaleHairLossOTPaymentInformation from "./components/FemaleHairLossOTPaymentInformation";
import EdPaymentInformation from "./components/EdPaymentInformation";
import MentalHealthPaymentInformation from "./components/MentalHealthPaymentInformation";
import SkinCarePaymentInformation from "src/pages/SkinCarePaymentInformation";
import SupplementsPaymentInformation from "./components/SupplementsPaymentInformation";
import InsuranceWeightLossPaymentInformation from "./components/InsuranceWeightLossPaymentInformation";
import OralGlp1PaymentInformation from "src/pages/OralGlp1PaymentInformation";
import DiabetesPaymentInformation from "./components/DiabetesPaymentInformation";

const Payment = () => {
  const oneTimeModel = useProduct(
    (product) => product.billing_model === "one_time",
  );
  const slug = useProduct((p) => p.slug);

  const { pathname } = useLocation();

  if (slug === "bc") {
    return <BirthControlPaymentInformation />;
  }

  if (slug === "mhl-ot") {
    return <MaleHairLossPaymentInformation />;
  }

  if (slug === "fhl-ot") {
    return <FemaleHairLossOTPaymentInformation />;
  }

  if (slug === "ed-ot") {
    return <EdPaymentInformation />;
  }

  if (["amh-ot", "bb-ot"].includes(slug)) {
    return <MentalHealthPaymentInformation />;
  }

  if (["aa-ot", "ac-ot", "ro-ot"].includes(slug)) {
    return <SkinCarePaymentInformation />;
  }

  if (["b-ot", "sl-ot"].includes(slug)) {
    return <SupplementsPaymentInformation />;
  }

  if (slug === "iwl-ot") {
    return <InsuranceWeightLossPaymentInformation />;
  }

  if (["wp-ot", "os-ot"].includes(slug)) {
    return <OralGlp1PaymentInformation />;
  }

  if (["db-ot", "cv-ot"].includes(slug)) {
    return <DiabetesPaymentInformation />;
  }

  if (oneTimeModel) {
    return pathname.includes(Paths.ADD_ONS) ? (
      <DashboardALaCartePaymentInformation />
    ) : (
      <ALaCartePaymentInformation />
    );
  }

  return <PaymentInformation />;
};

export default Payment;
